import React from 'react';
import { Modal, Button } from 'react-bootstrap';

const StatusConfirmationModal = ({ show, handleClose, handleDelete }) => {
  return (
    <Modal show={show} onHide={handleClose} size="lg" style={{ marginTop: '200px' }}>
      <Modal.Body>هل انت متاكد من مسح الاوردر من قائمه الاسترجاع؟</Modal.Body>
      <Modal.Footer className='d-flex justify-content-center'>
        <div className='d-flex gap-4 '>
          <Button style={{ backgroundColor: "#C99700", border: "none" }} onClick={handleDelete}>
            متاكد
          </Button>
          <Button className='ms-2' style={{ backgroundColor: "#C99700", border: "none" }} onClick={handleClose}>
            اغلاق
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default StatusConfirmationModal;
